import { useState } from 'react';

import Description from '../../components/Description/Description';
import PagesFooter from '../../components/PagesFooter/PagesFooter';
import PagesHeader from '../../components/PagesHeader/PagesHeader';
import Title from '../../components/Title/Title';
import UploadDocumentField from '../../components/UploadDocumentField/UploadDocumentField';
import { usePagesContext } from '../../context/PagesContext';
import { scrollToFieldWithError } from '../../helpers/scrollToFieldWithError';
import { useAppDispatch } from '../../hooks';
import useArnFromPath from '../../hooks/useArnFromPath';
import useComponentTracker from '../../hooks/useComponentTracker';
import useDefaultPagesAction from '../../hooks/useDefaultPagesAction';
import { usePageFocus } from '../../hooks/usePageFocusHook';
import usePagesConfig from '../../hooks/usePagesConfig';
import useSetBannerType from '../../hooks/useSetBannerType';
import useTranslation from '../../hooks/useTranslation';
import useValidation from '../../hooks/useValidation';
import { getApplicationState } from '../../store/application/application';
import { addOrUpdateFormField, patchForm } from '../../store/applicationform/applicationFormStore';
import { WizardPageAction } from '../../store/wizard/wizard';

// TODO: add to mocks when service is ready
// TODO: add translations

const DocumentUploadComplementInfoPage = () => {
    useComponentTracker('DocumentUploadPage');
    useSetBannerType('bannerThree');
    usePageFocus();
    const { totalSections } = usePagesConfig();
    const dispatch = useAppDispatch();
    const translate = useTranslation();
    const [_isError, setIsError] = useState(false);

    const validationErrors = useValidation([]); // TODO: Add fields to validate
    const { currentPage } = usePagesContext();
    const defaultPagesAction = useDefaultPagesAction();
    const applicationReferenceNumber = useArnFromPath();

    const onAction = async (action: WizardPageAction) => {
        if (action === 'next' && validationErrors.length) {
            scrollToFieldWithError(validationErrors);
            validationErrors.forEach((validationError) => {
                dispatch(addOrUpdateFormField(validationError));
            });
            return false;
        }

        try {
            await dispatch(
                patchForm({
                    applicationReferenceNumber: applicationReferenceNumber!,
                    formFieldStates: [
                        {
                            fieldName: 'CURRENT_APPLICATION_STATE_KEY',
                            value: 'COMPLEMENT_INFORMATION_MAIN_APPLICANT',
                        },
                    ],
                }),
            ).unwrap();
            setIsError(false);
            await dispatch(getApplicationState({ applicationReferenceNumber }));
            return true;
        } catch (error) {
            setIsError(true);
            throw error;
        }
    };

    return (
        <>
            <PagesHeader
                actions={[]}
                onAction={defaultPagesAction}
                currentPage={currentPage}
                currentSection={3}
                numberOfSections={totalSections}
                numberOfPagesInSection={4}
                currentPageInSection={3}
                sectionTitle={translate('field.section.your-account')}
            />
            <Title text={translate('page.document-upload.title')} />
            <Description text={translate('page.document-upload.description')} />
            <UploadDocumentField />
            <PagesFooter
                actions={['next']}
                onAction={onAction}
                currentSection={3}
                numberOfSections={totalSections}
                numberOfPagesInSection={4}
                currentPageInSection={3}
                sectionTitle={translate('field.section.your-account')}
            />
        </>
    );
};

export default DocumentUploadComplementInfoPage;
